/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Highcharts from 'highcharts'

window.yield_chart_options = {
  chart: {
    type: 'spline',
    renderTo: 'yield_chart'
  },
  title: {
    text: 'Yield Analysis Chart',
    zoomType: 'xy'
  },
  subtitle: {
    text: 'Implicit and historical yields should converge'
  },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      month: '%b. %Y',
      year: '%b'
    }
  },
  yAxis:
    [
      {
        title: {
          text: 'Yield (%)'
        }
      },
      {
        title: {
          text: 'Daily return (€)'
        },
        opposite: true
      }
    ],
  plotOptions: {
    series: {
      cursor: '',
      point: {
        events: {
          click: ''
        }
      }
    }
  },
  colors:
    ['#6CF', '#39F', '#000', '#036', '#000'],
  series: [
    {
      name: 'Daily Net Return',
      type: 'area',
      color: {
        linearGradient: {
          x1: 0,
          x2: 0,
          y1: 0,
          y2: 1
        },
        stops:
          [
            [0, '#CCC'],
            [1, '#FFFFFF']
          ]
      },
      yAxis: 1,
      marker: {
        enabled: false
      },
      tooltip: {
        headerFormat: "<b>{series.name}</b><br>",
        pointFormat: '{point.x:%e. %b}: {point.y:.2f} € '
      }

    },
    {
      name: 'Implicit Annualized Yield',
      type: 'spline',
      marker: {
        enabled: true
      }
    },
    {
      name: 'Historical Annualized Return',
      type: 'spline',
      marker: {
        enabled: true
      }
    },
  ],
  tooltip: {
    headerFormat: "<b>{series.name}</b><br>",
    pointFormat: '{point.x:%e. %b}: {point.y:.2f} (%) '
  }
};

window.total_return_chart_options = {
  chart: {
    type: 'spline',
    renderTo: 'total_return_chart'
  },
  title: {
    text: 'Total Returns Chart',
    zoomType: 'xy'
  },
  subtitle: {
    text: 'Gross returns grouped per month'
  },
  series: [{}],
  legend: '',
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      month: '%b. %Y',
      year: '%b'
    }
  },
  yAxis: {
    title: {
      text: 'Total return (€)'
    }
  }
};

const fetch_json = function(url) {
  return fetch(url, {headers: {Accept: 'application/json'}}).then((response) => response.json());
};

const draw_total_return_chart = function() {
  const element = document.querySelector('#total_return_chart');
  if (!element) return;
  const url = element.getAttribute('data-url');
  return fetch_json(url).then((data) => {
    total_return_chart_options.series[0].data = data.total_return_per_month;
    return new Highcharts.Chart('total_return_chart', total_return_chart_options);
  });
};

const draw_yield_chart = function() {
  const element = document.querySelector('#yield_chart');
  if (!element) return;
  const url = element.getAttribute('data-url');
  return fetch_json(url).then((data) => {
    yield_chart_options.series[0].data = data.daily_return;
    yield_chart_options.series[1].data = data.implicit_annualized_return;
    yield_chart_options.series[2].data = data.historical_annualized_return;
    yield_chart_options.plotOptions.series.cursor = 'pointer';
    yield_chart_options.plotOptions.series.point.events.click = function() {
      return window.open(this.bookingUrl);
    };
    yield_chart_options.yAxis[1].breakSize = 100;
    return new Highcharts.Chart('yield_chart', yield_chart_options);
  });
};

document.addEventListener("turbo:load", function() {
  try { draw_total_return_chart(); } catch (error) {}

  try { draw_yield_chart(); } catch (error1) {}
});

// Highcharts keeps every chart it builds in Highcharts.charts. Each turbo:load builds
// new ones, so destroy the live charts before Turbo caches the page to avoid leaking
// instances across visits.
document.addEventListener("turbo:before-cache", function() {
  Highcharts.charts.filter(Boolean).forEach((chart) => chart.destroy());
});
